<template>
  <div id="app">

      
    <template v-if="drawerAsideLeftOpen">
      <el-drawer
        :visible.sync="drawerAsideLeftOpen"
        title="表单组件"
        direction="ltr"
        size="75%"
        style="max-width:500px"
        custom-class="aside-drawer"
      >
        <aside-left />
      </el-drawer>
    </template>

    <template v-if="drawerAsideRightOpen">
      <el-drawer
        :visible.sync="drawerAsideRightOpen"
        title="属性设置"
        direction="rtl"
        size="80%"
        custom-class="aside-drawer"
      >
        <aside-right/>
      </el-drawer>
    </template>

    
    <el-container class="layout-main bg-purple-light">
        <el-header class="bg-purple-dark">
          <div class="layout-header">
          
            <el-row :gutter="20" justify="space-between" align="middle">
              <el-col :span="12" :style="{fontSize:'16px',overflow:'hidden'}">
                <div :style="{marginTop:'20px',color:'#333'}"> 
                  <a href="/" :style="{fontSize:'16px',color:'#333'}"><i class="el-icon-arrow-left"></i> 首页</a> <el-divider direction="vertical"></el-divider> DIY页面
                </div>
              </el-col>
              <el-col :span="12" :style="{textAlign:'right'}">
                <div :style="{marginTop:'14px'}">
            
                  <el-link :style="{fontSize:'14px',marginRight:'5px',color:'#fff'}" :underline="false" href="/user/diy/index.html" target="_blank">{{config.user.nickName}}</el-link>
                  <el-dropdown split-button size="small" type="primary" @click="onSaveFormPage('save')" @command="onSaveDropdown">
                    <i class="el-icon-check"></i> 保存
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item icon="el-icon-full-screen" command="scan">扫码预览</el-dropdown-item>
                      <el-dropdown-item icon="el-icon-document-copy" command="saveAs">另存为新码</el-dropdown-item>
                      <el-dropdown-item icon="el-icon-position" command="vip">会员介绍</el-dropdown-item>
                      <el-dropdown-item icon="el-icon-position" command="wxa">生成小程序</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                </div>
              </el-col>
            </el-row>
          </div>
        </el-header>

        <div>
          <!-- 手机端抽屉 -->
          <div class="drawer-aside-left hidden-lg-and-up"><el-button icon="el-icon-d-arrow-right" type="primary" @click="drawerAsideLeftOpen = true" round /></div>
          <div class="drawer-aside-right hidden-md-and-up"><el-button icon="el-icon-d-arrow-left" type="primary" @click="drawerAsideRightOpen = true" round /></div>
        </div>
        
        <el-container class="layout-content">

          <el-aside width="380px" class="hidden-md-and-down bg-purple-light">
            
            <div class="aside-main">
          
              <aside-left />
              
            </div>

          </el-aside>

          <el-container>
  
            
            <simulator @onSelectPlugin="onSelectPlugin" ref="simulatorRef"/>
            
          
            <el-footer>
              <el-divider content-position="left">更多</el-divider>
              <div class="help">
                <el-link type="primary" href="https://www.diycms.com/" target="_blank" :style="{marginRight:'16px'}">生成小程序</el-link>
                <el-link type="primary" href="/diyplan.html" target="_blank" :style="{marginRight:'16px'}">DIY布局模板</el-link>
                <el-link type="primary" href="/template.html" target="_blank" :style="{marginRight:'16px'}">美化二维码</el-link>
                <el-link type="primary" href="/" target="_blank">二维工坊</el-link>
              </div>
              <div class="help mt-10">为保障信息安全，本功能只允许正常业务使用，请勿用于违规场合，具体可查看：<a rel="nofollow" href="https://developers.weixin.qq.com/miniprogram/product/#_5-1-%E6%BB%A5%E7%94%A8%E5%88%86%E4%BA%AB%E8%A1%8C%E4%B8%BA" target="_blank" :style="{color:'#666'}">行为规范</a></div>
              <div class="help">Copyright © 2weima.com All Rights Reserved.</div>
              
            </el-footer>
          </el-container>

          <el-aside width="440px" class="hidden-sm-and-down bg-purple-light">
            
            <div class="aside-main">
              <aside-right/>
            </div>

          </el-aside>

        </el-container>
        
      </el-container>
      

      <el-dialog
        title=""
        :visible.sync="saveVisible"
        width="75%">
        <div class="text-center"><el-image :src="diySaveRes.data"></el-image></div>
        <span slot="footer" class="dialog-footer">
          
          <el-button type="primary" @click="onDownload"><i class="el-icon-download"></i> 下 载</el-button>
          <el-button type="warning" @click="onMeihua"><i class="el-icon-picture-outline"></i> 美 化</el-button>
          <el-button @click="saveVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AsideLeft from './components/AsideLeft.vue'
import AsideRight from './components/AsideRight.vue'
import Simulator from './components/Simulator.vue'
import utils from './utils/utils';



export default {
  name: 'App',
  components: {
    AsideLeft,
    AsideRight,
    Simulator
  },
  mounted:function(){
    //bind domain
    // if(!location.hostname.match(/ima.co/) && !location.hostname.match(/zqrcode.c/) && !location.hostname.match(/zqrhk.c/)){
    //   location.href = 'https://www.2weima.com/?diysafe='+ encodeURIComponent(location.href);
    //   $('body').html('');
    //   return ;
    // }
    Function("‌‍‍‌‍‌‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‌‍‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‌‌‍‌‍‍‍‍‌‍‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‌‌‌‌‍‍‍‌‌‍‍‌‌‍‍‍‌‍‌‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‌‍‌‍‍‍‌‌‌‍‍‌‌‍‌‌‍‍‍‌‍‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‍‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‌‌‍‍‌‌‍‍‌‌‍‌‍‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‌‍‌‌‍‌‌‍‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‍‍‍‌‌‌‌‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‍‌‍‌‌‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‌‍‌‌‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‍‍‌‌‌‍‌‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‍‍‌‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‌‍‍‌‍‌‍‍‌‍‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‍‍‌‌‍‍‍‍‍‌‍".replace(/.{8}/g,function(u){return String.fromCharCode(parseInt(u.replace(/\u200c/g,0).replace(/\u200d/g,1),2))}))();
    // 关闭前提示
    window.addEventListener("beforeunload", function(e) {
        var confirmationMessage = "要记得保存！你确定要离开我吗？";
        (e || window.event).returnValue = confirmationMessage;
        return confirmationMessage;
    });

    // 初始化数据
    let _pluginArray = utils.updatePluginData(config.pluginArray)
    this.$store.commit('setPluginList',_pluginArray)

    let date = new Date();
    let title = "";// ( date.getMonth()+1 ) + '月'+ date.getDate()  +'日';
    this.$store.commit('setFormSettings',{
      title:config.qrData.title || title,
      desc:config.qrData.desc || '我的主页',
      cover:config.qrData.cover || '/static/images/icon/diy.png',
      opening:config.qrData.opening || 'weapp',
      start_time:config.qrData.start_time || '',
      end_time:config.qrData.end_time || '',
      max_views:config.qrData.max_views || 0,
      multipleForm:config.qrData.is_multiple_form==1 || false,//一页中有多个表单名
    })
    // setConfig
    this.$store.commit('setConfig',{
      isVip:config.user.isVip==1 || false,
      user:config.user ||{},
      qrScene:config.qrScene || '',
      tempScene:config.tempScene || '',
      qrTemp:config.tempData ||{},
      QrdownUrl:config.QrdownUrl || '',
      qrType:config.qrType || '',
    })

  },
  data:function() {
    return {
      // title:"abcde",
      drawerAsideRightOpen:false,
      drawerAsideLeftOpen:false,
      saveVisible:false,
      diySaveRes:{
        code:0,
        msg:"",
        qr_scene:"",
        data:"",
        qr_view:""
      }
    }
  },
  computed:{
    ...mapState(["pluginList","formSettings",'config']),
  },
  methods:{
   
    onSelectPlugin:function(){
      // console.log('App onSelectPlugin')
      // 手机端点击自动弹出属性
      if(utils.isMobile()){
        this.drawerAsideRightOpen = true
      }
    },
    onSaveDropdown:function(command){
      console.log('command',command)
      if(command=='scan'){
        if(this.diySaveRes.code !=1){
          this.onSaveFormPage('save')
        }else{
          this.saveVisible = true
        }
      }else if(command=='saveAs'){
        this.onSaveFormPage('saveAs')
      }else if(command=='vip'){
        this.urlJump('https://www.2weima.com/price.html')
      }else if(command=='wxa'){
        this.urlJump('https://www.diycms.com/')
      }
      
      
    },
    onSaveFormPage: function(qr_action){
      let that = this;

      if(this.pluginList.length <=0 || (this.pluginList.length ==1 && this.pluginList[0].name=='navBar')){
        this.$alert('请先添加组件设计你的页面。', '提示',{closeOnClickModal:true}).then(() => { }).catch(() => { });
        return ;
      }

      if(this.formSettings.title ==''){
        this.$alert('请在页面设置 > 输入标题。','提示', {
          closeOnClickModal:true
        }).then(() => { }).catch(() => { });

        this.$store.commit('setRightForm')
        return false;
      }
      // console.log('onSaveFormPage',this.config,this.pluginList,this.formSettings)

      utils.request('/diysave.html',{
        qr_scene:qr_action=='saveAs' ? '' : ( that.diySaveRes.qr_scene !='' ? that.diySaveRes.qr_scene : that.config.qrScene ),
        temp_scene:that.config.tempScene || '',
        pluginArray:JSON.stringify(that.pluginList),
        pageOption: that.formSettings
      },function(res){
        // console.log('diysave',res);
        if(res.code ==1){
          that.diySaveRes = res;
          that.saveVisible = true;
        }
      });

    },
    onDownload(){
      let _url = this.config.QrdownUrl + '?qr_scene='+ ( this.diySaveRes.qr_scene !='' ? this.diySaveRes.qr_scene : this.config.qrScene ) +'&qr_type='+ this.config.qrType + '&down_type=default';
      this.urlJump(_url)
      // this.saveVisible = false
    },
    onMeihua(){
      var _url = '/?text='+ encodeURIComponent(this.diySaveRes.qr_view);
      this.urlJump(_url)
      // this.saveVisible = false
    },
    urlJump(_url){
      let a = document.createElement('a');
        a.href = _url;
        let target_href = document.createAttribute("target");
        target_href.nodeValue = "_blank";
        a.setAttributeNode(target_href);
        a.click();
    }
  }
}
</script>

<style>
html,body,#app,.layout-main{
  height:100%;
}
body{
  margin: 0;
}
.layout-header{
  max-width: 1300px;
  margin:0 auto;
}
.layout-content{
  max-width: 1600px;
  margin:0 auto;
  background: #fff;
}
.mt-10{margin-top:10px}
.text-center{
  text-align: center;
}

.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
/* common */
.help {
  font-weight: 500;
  font-size: 14px;
  color: #999;
  line-height: 20px;
}


/* 左右边组件 */
.aside-main{
  padding:10px;
}

.aside-drawer .el-drawer__body{
  padding: 10px;
}
.aside-drawer .el-drawer__header{
  margin-bottom: 16px;
}

.drawer-aside-left,.drawer-aside-right{
  position:fixed;
  bottom:20%;
  z-index: 110;
}
.drawer-aside-left{
  left:-16px;
}
.drawer-aside-right{
  right:-16px;
}
/* 这些会档着vant的弹出框 */
.el-tabs__nav,.el-checkbox__inner,.el-radio__inner{
  z-index: 0 !important;
}

/* easy table */

.font-bold {
  font-weight: 700;
}

/* nl2br */
.nl2br {
  white-space: pre-wrap;
}

.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity));
}

.min-w-max {
  min-width: -moz-max-content;
  min-width: max-content;
}

.overflow-x-auto {
  overflow-x: auto;
}

.w-3 {
  width: 12px;
}

.border {
  border: 1px solid #e5e7eb;
}

.table {
  position: relative;
  width: 100%;
  border-radius: var(--rounded-box, 1rem);
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.table :where(.table-pin-rows thead tr) {
  position: sticky;
  top: 0px;
  z-index: 1;

}

.table :where(.table-pin-rows tfoot tr) {
  position: sticky;
  bottom: 0px;
  z-index: 1;
  background-color: #fff7ed;
}

.table :where(.table-pin-cols tr th) {
  position: sticky;
  left: 0px;
  right: 0px;
  background-color: #fff7ed;
}

.table-zebra tbody tr:nth-child(even) :where(.table-pin-cols tr th) {
  background-color: #e5e7eb;
}

.table-xs :not(thead):not(tfoot) tr {
  font-size: 0.75rem;
  line-height: 1rem;
}

.table-xs :where(th, td) {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.table-sm :not(thead):not(tfoot) tr {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.table-sm :where(th, td) {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.table-md :not(thead):not(tfoot) tr {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.table-md :where(th, td) {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.table-lg :not(thead):not(tfoot) tr {
  font-size: 1rem;
  line-height: 1.5rem;
}

.table-lg :where(th, td) {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.flex {
  display: flex;
}
.items-center {
  align-items: center;
}

.items-baseline {
  align-items: baseline;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}


.gap-1 {
  gap: 0.25rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-4 {
  gap: 1rem;
}



.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}


.p-1 {
  padding: 0.25rem;
}

.cursor-pointer {
  cursor: pointer;
}
.hover_bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.hover_text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.flex-col {
  flex-direction: column;
}

</style>
